import React, {
  useCallback,
  useEffect,
  useState,
  useRef,
  MutableRefObject,
} from 'react';
import { Link } from 'react-router-dom';
import ChicagoGovLogo from '_design/sass/img/chicago.gov-logo.png';
import MobileClose from '_design/sass/img/close.svg';
import CdsHeaderTrustedSite from './CdsHeaderTrustedSite';

type CdsHeaderProps = {
  topRight: React.ReactNode;
  alertBanner?: React.ReactNode;
  children: React.ReactNode;
};

const CdsHeader = (props: CdsHeaderProps) => {
  const btnRef = useRef() as MutableRefObject<HTMLButtonElement>;
  const wrapperRef = useRef() as MutableRefObject<HTMLDivElement>;
  const [isVisible, setVisibility] = useState(false);
  const toggleVisibility = useCallback(() => {
    setVisibility((prev) => !prev);
  }, []);

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick, false);
    return () => {
      document.removeEventListener('click', handleDocumentClick, false);
    };
  }, []);

  const handleDocumentClick = (event: Event) => {
    const menuRefs = [wrapperRef, btnRef];
    if (
      !menuRefs.some(
        (ref) => ref.current && ref.current.contains(event.target as Node)
      )
    ) {
      setVisibility(false);
    }
  };

  return (
    <>
      <CdsHeaderTrustedSite />
      {props.alertBanner && props.alertBanner}
      <header className='cds-header mb-4'>
        <div className='cds-navbar' role='banner'>
          {/* Menu button for mobile */}
          <button
            className='cds-menu-btn'
            type='button'
            onClick={toggleVisibility}
            ref={btnRef}
          >
            MENU
          </button>
          <div className='cds-logo' id='logo'>
            <em className='cds-logo-text'>
              <Link to='/' title='Home'>
                <img src={ChicagoGovLogo} alt='Logo of the City of Chicago' />
                <h1 className='cds-header-title'>BACP</h1>
              </Link>
            </em>
          </div>
        </div>
        <nav
          role='navigation'
          className={`cds-nav ${isVisible ? 'is-visible' : ''}`}
          ref={wrapperRef}
        >
          <div className='cds-nav-inner'>
            <button
              className='cds-nav-close'
              type='button'
              onClick={toggleVisibility}
            >
              <img src={MobileClose} alt='Close' />
            </button>
            <div
              className='cds-nav-secondary cds-nav-search text-right'
              onClick={toggleVisibility}
            >
              <ul className='cds-nav-secondary-links'>{props.topRight}</ul>
            </div>
            <div onClick={toggleVisibility}>{props.children}</div>
          </div>
        </nav>
      </header>
    </>
  );
};

export default CdsHeader;
